import { Box, Grid, List, ListItemButton, Paper, Toolbar, Typography ,Divider, Avatar} from '@mui/material';
import React from 'react';

const BsReports = () => {
    const paperStyles = {
        borderRadius: "8px",
        // height: "100%",
        overflow: "scroll",
    };
  return (
    <div>
          
              
          <Grid container spacing={1}>
              <Grid item xs={2.4}>
                  <Paper elevation={2}>
                      <Box>
                          <Toolbar
                              sx={{
                                  minHeight: "48px !important",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 3,
                                  bgcolor: "#fff",
                              }}
                          >
                              <Typography>Candidates</Typography>
                          </Toolbar>
                          <Divider />
                      </Box>
                      <Box>
                          <List>
                              <ListItemButton>
                                  <Box display="flex" alignItems="center" gap={2}>
                                      <Avatar>
                                          
                                      </Avatar>
                                      <Box>
                                          <Typography variant='body1' style={{ fontSize: "12px", fontWeight: "600" }}>James</Typography>
                                          <Typography variant='body2' style={{ fontSize: "11px" }}>React Developer</Typography>
                                      </Box>
                                  </Box>
                              </ListItemButton>
                          </List>
                         
                      </Box>
                  </Paper>
                  
              </Grid>
              <Grid item xs={2.4}>
                  <Paper elevation={2}>
                      <Box>
                          <Toolbar
                              sx={{
                                  minHeight: "48px !important",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 3,
                                  bgcolor: "#fff",
                              }}
                          >
                              <Typography>Vendor</Typography>
                          </Toolbar>
                          <Divider />
                      </Box>
                      <Box>
                          <List>
                              <ListItemButton>
                                  <Box display="flex" alignItems="center" gap={2}>
                                      <Avatar>

                                      </Avatar>
                                      <Box>
                                          <Typography variant='body1' style={{ fontSize: "12px", fontWeight: "600" }}>Accenture</Typography>
                                          <Typography variant='body2' style={{ fontSize: "11px" }}>Location</Typography>
                                      </Box>
                                  </Box>
                              </ListItemButton>
                          </List>

                      </Box>
                  </Paper>

              </Grid>
             
              <Grid item xs={2.4}>
                  <Paper elevation={2}>
                      <Box>
                          <Toolbar
                              sx={{
                                  minHeight: "48px !important",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 3,
                                  bgcolor: "#fff",
                              }}
                          >
                              <Typography>Rate</Typography>
                          </Toolbar>
                          <Divider />
                      </Box>
                      <Box>

                      </Box>
                  </Paper>
              </Grid>
              <Grid item xs={2.4}>
                  <Paper elevation={2}>
                      <Box>
                          <Toolbar
                              sx={{
                                  minHeight: "48px !important",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 3,
                                  bgcolor: "#fff",
                              }}
                          >
                              <Typography>Recruiters</Typography>
                          </Toolbar>
                          <Divider />
                      </Box>
                      <Box>

                      </Box>
                  </Paper>
              </Grid>

              <Grid item xs={2.4}>
                  <Paper elevation={2}>
                      <Box>
                          <Toolbar
                              sx={{
                                  minHeight: "48px !important",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 3,
                                  bgcolor: "#fff",
                              }}
                          >
                              <Typography> Status</Typography>
                          </Toolbar>
                          <Divider />
                      </Box>
                      <Box>

                      </Box>
                  </Paper>
              </Grid>


              
      </Grid>
    </div>
  );
}

export default BsReports;
